/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { EnumerationValueDto } from './EnumerationValueDto';
import {
    EnumerationValueDtoFromJSON,
    EnumerationValueDtoFromJSONTyped,
    EnumerationValueDtoToJSON,
} from './EnumerationValueDto';
import type { NumericValueDto } from './NumericValueDto';
import {
    NumericValueDtoFromJSON,
    NumericValueDtoFromJSONTyped,
    NumericValueDtoToJSON,
} from './NumericValueDto';

/**
 * 
 * @export
 * @interface BeamShapingGroupCircularDto
 */
export interface BeamShapingGroupCircularDto {
    /**
     * 
     * @type {string}
     * @memberof BeamShapingGroupCircularDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BeamShapingGroupCircularDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeamShapingGroupCircularDto
     */
    groupName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeamShapingGroupCircularDto
     */
    groupHash?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeamShapingGroupCircularDto
     */
    groupId?: string;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof BeamShapingGroupCircularDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {EnumerationValueDto}
     * @memberof BeamShapingGroupCircularDto
     */
    radiationFieldShape?: EnumerationValueDto;
    /**
     * 
     * @type {EnumerationValueDto}
     * @memberof BeamShapingGroupCircularDto
     */
    radiationFieldSymmetry?: EnumerationValueDto;
    /**
     * 
     * @type {NumericValueDto}
     * @memberof BeamShapingGroupCircularDto
     */
    radiationFieldSize?: NumericValueDto;
    /**
     * 
     * @type {string}
     * @memberof BeamShapingGroupCircularDto
     */
    $type?: BeamShapingGroupCircularDtoTypeEnum;
}


/**
 * @export
 */
export const BeamShapingGroupCircularDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoSystemSetupParametersBeamShapingGroupCircularDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.BeamShapingGroupCircularDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type BeamShapingGroupCircularDtoTypeEnum = typeof BeamShapingGroupCircularDtoTypeEnum[keyof typeof BeamShapingGroupCircularDtoTypeEnum];



/**
 * Check if a given object implements the BeamShapingGroupCircularDto interface.
 */
export function instanceOfBeamShapingGroupCircularDto(value?: unknown): value is BeamShapingGroupCircularDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(BeamShapingGroupCircularDtoTypeEnum)[0];
}

export function BeamShapingGroupCircularDtoFromJSON(json: any): BeamShapingGroupCircularDto {
    return BeamShapingGroupCircularDtoFromJSONTyped(json, false);
}

export function BeamShapingGroupCircularDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BeamShapingGroupCircularDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'groupName': json['groupName'] == null ? undefined : json['groupName'],
        'groupHash': json['groupHash'] == null ? undefined : json['groupHash'],
        'groupId': json['groupId'] == null ? undefined : json['groupId'],
        'origin': json['origin'] == null ? undefined : EntityOriginFromJSON(json['origin']),
        'radiationFieldShape': json['radiationFieldShape'] == null ? undefined : EnumerationValueDtoFromJSON(json['radiationFieldShape']),
        'radiationFieldSymmetry': json['radiationFieldSymmetry'] == null ? undefined : EnumerationValueDtoFromJSON(json['radiationFieldSymmetry']),
        'radiationFieldSize': json['radiationFieldSize'] == null ? undefined : NumericValueDtoFromJSON(json['radiationFieldSize']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function BeamShapingGroupCircularDtoToJSON(value?: BeamShapingGroupCircularDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'name': value['name'],
        'groupName': value['groupName'],
        'groupHash': value['groupHash'],
        'groupId': value['groupId'],
        'origin': EntityOriginToJSON(value['origin']),
        'radiationFieldShape': EnumerationValueDtoToJSON(value['radiationFieldShape']),
        'radiationFieldSymmetry': EnumerationValueDtoToJSON(value['radiationFieldSymmetry']),
        'radiationFieldSize': NumericValueDtoToJSON(value['radiationFieldSize']),
        '$type': value['$type'],
    });
}

